import { forwardRef, type ComponentProps, type ComponentRef } from 'react';
import clsx from 'clsx';
import { Switch as MuiSwitch } from '@mui/material';

export type RwSwitchProps = ComponentProps<typeof MuiSwitch>;

// No dedicated .rw-switch atom in the DS CSS — the DS names this control "toggle"
// (.rw-toggle), so that's the class Switch wires to.
export const RwSwitch = forwardRef<ComponentRef<typeof MuiSwitch>, RwSwitchProps>(function RwSwitch({ className, ...props }, ref) {
  return <MuiSwitch ref={ref} className={clsx('rw-toggle', className)} {...props} />;
});
